import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SuccessHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sessionId = queryParams.get('session_id');
    const userId = queryParams.get('user_id');
    const paymentMethod = queryParams.get('payment_method');

    if (sessionId && userId && paymentMethod) {
      const fetchPaymentStatus = async () => {
        try {
          const response = await fetch(
            `https://backend.printtrio.co.uk/api/stripe/success${location.search}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
            }
          );

          const data = await response.json();

          // Check the payment status in the response
          if (data.status === 'success') {
            const pendingPurchaseRaw = sessionStorage.getItem('printtrio_pending_purchase');
            if (pendingPurchaseRaw) {
              try {
                const pendingPurchase = JSON.parse(pendingPurchaseRaw);
                const transactionId =
                  data.order_id ||
                  data.transaction_id ||
                  data.payment_intent ||
                  sessionId;

                sessionStorage.setItem(
                  'printtrio_order_confirmation',
                  JSON.stringify({
                    ...pendingPurchase,
                    transaction_id: String(transactionId || ''),
                  })
                );
              } catch (parseError) {
                console.error('Error parsing pending purchase tracking payload:', parseError);
              } finally {
                sessionStorage.removeItem('printtrio_pending_purchase');
              }
            }

            // Payment successful, redirect to confirmation page
            navigate('/order-confirmation');
          } else {
            sessionStorage.removeItem('printtrio_pending_purchase');
            sessionStorage.removeItem('printtrio_order_confirmation');
            // Payment failed or incomplete, redirect back to cart
            navigate('/Cart');
          }
        } catch (error) {
          console.error('Error processing payment success:', error);
          sessionStorage.removeItem('printtrio_pending_purchase');
          sessionStorage.removeItem('printtrio_order_confirmation');
          // On error, redirect to cart
          navigate('/Cart');
        }
      };

      fetchPaymentStatus();
    } else {
      sessionStorage.removeItem('printtrio_pending_purchase');
      sessionStorage.removeItem('printtrio_order_confirmation');
      // If required params are missing, redirect to cart
      navigate('/Cart');
    }
  }, [location, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p>Processing your payment, please wait...</p>
    </div>
  );
};

export default SuccessHandler;
